import React from 'react';
import { Stack, TextField, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { textFieldStyles, secondaryIconColor } from '../styles';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
}

/**
 * Search input with clear button.
 */
const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1 }}>
      <SearchIcon sx={{ color: secondaryIconColor }} />
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        sx={textFieldStyles}
      />
      {value && (
        <IconButton
          size="small"
          onClick={onClear}
          sx={{ color: secondaryIconColor }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};

export default SearchBar;
